<template>
	<div class="f-files inputfield inputfield--files">
		<div class="row">
			<div class="col-xs-12 col-sm-4 col-md-3" v-for="file in field.value">
				<div class="f-files__card">
					<img class="f-files__entry f-files__entry--image" v-if="file.type == 'image'" :src="file.url" :alt="file.description ? file.description : ' '">
					<div class="f-files__entry f-files__entry--file" v-else>
						<i v-if="file.icon" class="fa" :class="'fa-' + file.icon"></i>
					</div>
					<a class="st-btn st-btn--highlight st-btn--small" download :href="file.url">{{ $t('Download {name}', {name: file.basename}) }}</a>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-xs-12">
				<vue-dropzone
				ref="dropzone"
				id="dropzone"
				vdropzone-success="uploadSuccess"
				:options="dropzoneOptions"></vue-dropzone>
			</div>
		</div>
	</div>
</template>

<script>
import vueDropzone from 'vue2-dropzone';
import fieldvalidation from '@/helpers/fieldvalidation';

import forEach from 'lodash/forEach';

export default {
	name: 'f-files',
	components: {
		vueDropzone,
    },
	computed: {
		systemdisable(){
			let field = this.$store.getters.getEditFieldById(this.field.name);
			return field.disabled || this.$store.getters.loading || this.$store.getters.saveing;
		},
	  	value: {
		    get () {
		    	let field = this.$store.getters.getEditFieldById(this.field.name);
		      	return field.value
		    },
		    set (value) {
		    	let field = this.$store.getters.getEditFieldById(this.field.name);
		    	field.value = value;
		    }
		}
	},
	props: {
		field: {
			type: Object,
			default: function(){
				return {};
			}
		}
	},
	data() {
  		const channel = this.$store.getters.channel;
		return {
			fileEl: null,
			dropzoneOptions: {
				acceptedFiles: "image/*",
				paramName: '',
				maxFiles: 1,
				addRemoveLinks: true,
				url: channel.urls.assets.replace(':fieldname:', 'asset'),
				thumbnailWidth: 400,
				thumbnailHeight: 300,
				maxFilesize: 5 // 5 MB
	      	}
		};
	},
	created(){
		this.dropzoneOptions.paramName = this.field.name;
		if(this.field.action) this.dropzoneOptions.url = this.field.action;
	},
	mounted(){
		const self = this;
		if(this.$refs.dropzone && this.field.value){
			forEach(this.field.value, (file, index) => {

				self.$refs.dropzone.manuallyAddFile({
					name: file.basename,
					size: (file.size ? file.size : 0)
				}, file.url);
			})

			// this.value = this.field.value;
			// const size = (file.size ? file.size.size : 0);


		}
	},
	methods: {
		...fieldvalidation
	},
	uploadSuccess(file, response){
		console.log('uploadSuccess', file, response);
	}
}
</script>

<style lang="scss">

.f-files{
	&__card {
		border: 1px solid black;
		overflow: hidden;
		padding: .5em;
	}
	&__entry {

		&--image {

		}
		&--file {
			.fa {
				font-size: 3rem;
			}
		}
	}
}

</style>



// WEBPACK FOOTER //
// src/components/form/f-files.vue